export default __webpack_public_path__ + "static/media/default.a99c5ba1.jpg";